// extracted by mini-css-extract-plugin
export default {"page":"Er_EJ8"};